"use client";

import { c as _c } from "react/compiler-runtime";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { useCallback, useEffect, useState } from "react";
import { tooltipVariants } from "../../styles/utils/tooltip";
import { classNames } from "../../utils";
/**
 * Displays rich content in a portal, triggered by a button.
 */
export function Popover(t0) {
  const $ = _c(48);
  let children;
  let className;
  let content;
  let defaultOpen;
  let disabled;
  let modal;
  let onOpenChange;
  let open;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== t0) {
    ({
      open,
      defaultOpen,
      onOpenChange,
      content,
      children,
      className,
      disabled,
      align: t1,
      sideOffset: t2,
      animation: t3,
      portal: t4,
      modal,
      hideOnScroll: t5,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = content;
    $[4] = defaultOpen;
    $[5] = disabled;
    $[6] = modal;
    $[7] = onOpenChange;
    $[8] = open;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    children = $[1];
    className = $[2];
    content = $[3];
    defaultOpen = $[4];
    disabled = $[5];
    modal = $[6];
    onOpenChange = $[7];
    open = $[8];
    props = $[9];
    t1 = $[10];
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
  }
  const align = t1 === undefined ? "center" : t1;
  const sideOffset = t2 === undefined ? 4 : t2;
  const animation = t3 === undefined ? "fade-in" : t3;
  const portal = t4 === undefined ? true : t4;
  const hideOnScroll = t5 === undefined ? false : t5;
  const [openedState, setOpenedState] = useState(Boolean(defaultOpen ?? open));
  const resolvedOpen = hideOnScroll ? openedState : open;
  let t6;
  let t7;
  if ($[15] !== hideOnScroll || $[16] !== open) {
    t6 = () => {
      if (hideOnScroll && open !== undefined) {
        setOpenedState(open);
      }
    };
    t7 = [hideOnScroll, open];
    $[15] = hideOnScroll;
    $[16] = open;
    $[17] = t6;
    $[18] = t7;
  } else {
    t6 = $[17];
    t7 = $[18];
  }
  useEffect(t6, t7);
  let t8;
  if ($[19] !== hideOnScroll || $[20] !== onOpenChange) {
    t8 = newOpen => {
      if (hideOnScroll) {
        setOpenedState(newOpen);
      }
      onOpenChange?.(newOpen);
    };
    $[19] = hideOnScroll;
    $[20] = onOpenChange;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const handleOnOpenChange = t8;
  let t10;
  let t9;
  if ($[22] !== handleOnOpenChange || $[23] !== hideOnScroll || $[24] !== resolvedOpen) {
    t9 = () => {
      if (!(hideOnScroll && resolvedOpen)) {
        return;
      }
      const handleScroll = () => {
        handleOnOpenChange(false);
      };
      document.addEventListener("scroll", handleScroll, {
        capture: true,
        passive: true
      });
      return () => {
        document.removeEventListener("scroll", handleScroll, {
          capture: true
        });
      };
    };
    t10 = [hideOnScroll, resolvedOpen, handleOnOpenChange];
    $[22] = handleOnOpenChange;
    $[23] = hideOnScroll;
    $[24] = resolvedOpen;
    $[25] = t10;
    $[26] = t9;
  } else {
    t10 = $[25];
    t9 = $[26];
  }
  useEffect(t9, t10);
  if (disabled || !content) {
    return children;
  }
  let t11;
  if ($[27] !== animation || $[28] !== className) {
    t11 = classNames("overflow-auto", "min-w-[var(--radix-popover-trigger-width)]", "max-h-[350px] p-2", tooltipVariants({
      animation
    }), className);
    $[27] = animation;
    $[28] = className;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== align || $[31] !== content || $[32] !== props || $[33] !== sideOffset || $[34] !== t11) {
    t12 = <PopoverPrimitive.Content align={align} className={t11} sideOffset={sideOffset} {...props}>{content}</PopoverPrimitive.Content>;
    $[30] = align;
    $[31] = content;
    $[32] = props;
    $[33] = sideOffset;
    $[34] = t11;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  const popoverContent = t12;
  const t13 = hideOnScroll ? undefined : defaultOpen;
  let t14;
  if ($[36] !== children) {
    t14 = <PopoverPrimitive.Trigger asChild={true}>{children}</PopoverPrimitive.Trigger>;
    $[36] = children;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== popoverContent || $[39] !== portal) {
    t15 = portal ? <PopoverPrimitive.Portal>{popoverContent}</PopoverPrimitive.Portal> : popoverContent;
    $[38] = popoverContent;
    $[39] = portal;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== handleOnOpenChange || $[42] !== modal || $[43] !== resolvedOpen || $[44] !== t13 || $[45] !== t14 || $[46] !== t15) {
    t16 = <PopoverPrimitive.Root defaultOpen={t13} modal={modal} onOpenChange={handleOnOpenChange} open={resolvedOpen}>{t14}{t15}</PopoverPrimitive.Root>;
    $[41] = handleOnOpenChange;
    $[42] = modal;
    $[43] = resolvedOpen;
    $[44] = t13;
    $[45] = t14;
    $[46] = t15;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  return t16;
}